import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
//----------------SLICES------------------//
import metaDataReducer from "./rtkSlices/metaDataSlice";
import conversationsReducer from "./rtkSlices/conversationsSlice";
import onboardingReducer from "./rtkSlices/onboardingSlice";
// //--------------SERVICES------------------//
import { signinApi } from "./services/auth";
import { chatApi } from "./services/chat";
import { tokenApi } from "./services/token";
import { userApi } from "./services/user";

export const store = configureStore({
  reducer: {
    metaData: metaDataReducer,
    conversations: conversationsReducer,
    onboarding: onboardingReducer,
    [signinApi.reducerPath]: signinApi.reducer,
    [chatApi.reducerPath]: chatApi.reducer,
    [tokenApi.reducerPath]: tokenApi.reducer,
    [userApi.reducerPath]: userApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(signinApi.middleware)
      .concat(chatApi.middleware)
      .concat(userApi.middleware)
      .concat(tokenApi.middleware),
});

setupListeners(store.dispatch);
export type RootState = ReturnType<typeof store.getState>;

